var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 261,
    height: 214,
    viewBox: "0 0 261 214",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.05078 98.1488V100.351",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.10352 99.3414L5.90276 101.194",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 104.272H4.5441",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.89844 109.29L5.69768 107.438",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.05078 109.892V107.69",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7199 108.424L11.252 106.956",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.655 104.754H13.4531",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1867 99.6167L12.7188 101.085",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M127.217 2V3.46791",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M122.814 6.40381H124.282",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M127.217 10.8075V9.3396",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M130.886 6.40381H129.418",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0781 63.6526V65.8545",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4707 70.2583H37.6726",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0781 76.13V73.9281",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9499 70.2583H45.748",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M200.065 143.683C201.819 143.683 203.242 145.106 203.242 146.86C203.242 148.615 201.819 150.038 200.065 150.038C198.311 150.038 196.889 148.615 196.889 146.86",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.604 114.856C216.49 114.268 219.381 111.961 220.05 109.479C220.657 111.673 223.201 114.268 225.497 114.464C222.913 115.379 220.442 118.097 220.05 120.232C219.783 118.056 216.366 115.173 214.604 114.856",
    fill: "#EBECEE"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9922 142.704C21.9356 142.41 23.3805 141.257 23.7151 140.016C24.0186 141.112 25.2903 142.41 26.4381 142.508C25.1464 142.965 23.9114 144.325 23.7151 145.392C23.5818 144.304 21.8732 142.862 20.9922 142.704",
    fill: "#EBECEE"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4985 40.6041C38.4985 41.9653 37.3956 43.0679 36.0354 43.0679C34.6745 43.0679 33.5723 41.9653 33.5723 40.6041C33.5723 39.2436 34.6745 38.1404 36.0354 38.1404C37.3956 38.1404 38.4985 39.2436 38.4985 40.6041",
    fill: "#D1D8DF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.974 47.2197C202.974 49.494 201.131 51.3376 198.858 51.3376C196.583 51.3376 194.74 49.494 194.74 47.2197C194.74 44.9454 196.583 43.1018 198.858 43.1018C201.131 43.1018 202.974 44.9454 202.974 47.2197",
    fill: "#EBECEE"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.001 36.0628C260.001 37.8671 258.54 39.3293 256.736 39.3293C254.932 39.3293 253.471 37.8671 253.471 36.0628C253.471 34.2584 254.932 32.7963 256.736 32.7963C258.54 32.7963 260.001 34.2584 260.001 36.0628",
    fill: "#EBECEE"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.5309 188.622C84.5309 189.76 83.6093 190.682 82.4722 190.682C81.3356 190.682 80.4141 189.76 80.4141 188.622C80.4141 187.485 81.3356 186.563 82.4722 186.563C83.6093 186.563 84.5309 187.485 84.5309 188.622Z",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.3071 24.776C83.3071 26.1372 82.2042 27.2398 80.844 27.2398C79.4837 27.2398 78.3809 26.1372 78.3809 24.776C78.3809 23.4154 79.4837 22.3123 80.844 22.3123C82.2042 22.3123 83.3071 23.4154 83.3071 24.776Z",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.134 211.425C144.56 212.024 142.799 211.233 142.2 209.66C141.601 208.085 142.391 206.323 143.966 205.724C145.539 205.125 147.301 205.916 147.9 207.49C148.499 209.064 147.708 210.826 146.134 211.425Z",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.2 153.195H85.0126C80.7762 153.195 77.3086 149.717 77.3086 145.467V59.6359C77.3086 55.3853 80.7762 51.9092 85.0126 51.9092H145.2C149.438 51.9092 152.906 55.3853 152.906 59.6359V145.467C152.906 149.717 149.438 153.195 145.2 153.195",
    fill: "#E0E2EE"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.064 156.865H79.8758C75.6395 156.865 72.1719 153.387 72.1719 149.137V63.3057C72.1719 59.0551 75.6395 55.579 79.8758 55.579H140.064C144.302 55.579 147.769 59.0551 147.769 63.3057V149.137C147.769 153.387 144.302 156.865 140.064 156.865",
    fill: "#E8EBF2"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.065 159.762H74.7531C70.508 159.762 67.0332 156.299 67.0332 152.066V66.5902C67.0332 62.3573 70.508 58.8955 74.7531 58.8955H135.065C139.312 58.8955 142.787 62.3573 142.787 66.5902V152.066C142.787 156.299 139.312 159.762 135.065 159.762",
    fill: "#D8DBEA"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.065 159.762H74.7531C70.508 159.762 67.0332 156.299 67.0332 152.066V66.5902C67.0332 62.3573 70.508 58.8955 74.7531 58.8955H135.065C139.312 58.8955 142.787 62.3573 142.787 66.5902V152.066C142.787 156.299 139.312 159.762 135.065 159.762",
    fill: "#F1F2F7"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.371 84.9373H81.8233C80.5511 84.9373 79.5098 83.9466 79.5098 82.7363C79.5098 81.5243 80.5511 80.5336 81.8233 80.5336H126.371C127.643 80.5336 128.685 81.5243 128.685 82.7363C128.685 83.9466 127.643 84.9373 126.371 84.9373",
    fill: "#E0E2EE"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.371 98.1486H81.8233C80.5511 98.1486 79.5098 97.1579 79.5098 95.9476C79.5098 94.7356 80.5511 93.7449 81.8233 93.7449H126.371C127.643 93.7449 128.685 94.7356 128.685 95.9476C128.685 97.1579 127.643 98.1486 126.371 98.1486",
    fill: "#E0E2EE"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.371 111.36H81.8233C80.5511 111.36 79.5098 110.369 79.5098 109.159C79.5098 107.949 80.5511 106.956 81.8233 106.956H126.371C127.643 106.956 128.685 107.949 128.685 109.159C128.685 110.369 127.643 111.36 126.371 111.36",
    fill: "#E0E2EE"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.371 124.571H81.8233C80.5511 124.571 79.5098 123.58 79.5098 122.37C79.5098 121.158 80.5511 120.167 81.8233 120.167H126.371C127.643 120.167 128.685 121.158 128.685 122.37C128.685 123.58 127.643 124.571 126.371 124.571",
    fill: "#E0E2EE"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.077 137.782H81.8332C80.5556 137.782 79.5098 136.792 79.5098 135.581C79.5098 134.369 80.5556 133.379 81.8332 133.379H105.077C106.354 133.379 107.4 134.369 107.4 135.581C107.4 136.792 106.354 137.782 105.077 137.782",
    fill: "#E0E2EE"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.99 120.708C143.083 129.614 129.292 130.619 119.28 123.743C118.001 122.848 116.783 121.843 115.647 120.708C115.063 120.125 114.512 119.524 113.993 118.891C112.954 117.627 112.044 116.278 111.299 114.885C109.986 112.532 109.093 110.035 108.606 107.454C107.033 99.3601 109.385 90.6481 115.647 84.3881C121.925 78.1094 130.639 75.7731 138.734 77.3306C141.314 77.833 143.813 78.7257 146.166 80.0236C147.562 80.7856 148.892 81.6951 150.158 82.7334C150.789 83.2507 151.391 83.8035 151.974 84.3881C153.111 85.5235 154.131 86.7393 155.009 88.0204C161.888 98.0286 160.881 111.818 151.99 120.708",
    fill: "white",
    fillOpacity: 0.1
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.499 118.954C140.231 128.223 125.213 128.221 115.944 118.954C106.687 109.697 106.687 94.6766 115.956 85.4092C125.213 76.1522 140.231 76.1522 149.489 85.4092C158.756 94.6766 158.756 109.697 149.499 118.954M154.254 80.6477C142.359 68.7522 123.083 68.7522 111.187 80.6477C99.2935 92.5415 99.2831 111.83 111.177 123.725C122.003 134.548 138.972 135.524 150.907 126.638C152.073 125.769 153.196 124.794 154.266 123.725C155.336 122.654 156.31 121.532 157.177 120.366C166.064 108.429 165.079 91.4723 154.254 80.6477",
    fill: "#E0E2EE"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.069 168.566L200.57 169.065C197.266 172.371 191.855 172.371 188.55 169.065L158.043 138.558L170.562 126.039L201.069 156.546C204.375 159.851 204.375 165.26 201.069 168.566",
    fill: "url(#paint0_linear_1426_49148)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.836 119.433L166.851 128.448L160.451 134.847L151.438 125.832C152.627 124.945 153.771 123.951 154.865 122.86C155.956 121.769 156.951 120.623 157.836 119.433",
    fill: "#E0E2EE"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.613 156.171L188.173 168.609L185.934 166.368L198.372 153.93L200.613 156.171Z",
    fill: "#EF545F"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.253 126.47L158.473 139.25L156.574 137.352L169.355 124.571L171.253 126.47Z",
    fill: "url(#paint1_linear_1426_49148)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.364 82.2207L112.021 113.562C110.841 111.446 110.038 109.201 109.602 106.881L136.683 79.7997C139.001 80.253 141.248 81.0539 143.364 82.2207",
    fill: "white",
    fillOpacity: 0.5
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.638 89.6701L119.753 121.635C118.54 120.836 117.385 119.937 116.308 118.921C115.753 118.398 115.229 117.862 114.738 117.295L149.036 84.9373C149.636 85.4018 150.207 85.8965 150.759 86.4196C151.836 87.4357 152.805 88.5236 153.638 89.6701",
    fill: "white",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1426_49148",
    x1: 180.796,
    y1: 103.286,
    x2: 135.29,
    y2: 148.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF62A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1426_49148",
    x1: 163.914,
    y1: 117.232,
    x2: 149.235,
    y2: 131.911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF404E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF62A5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchEmpty);
export default __webpack_public_path__ + "static/media/search_empty.053edd09c4b043d6a6e47b10e40b6614.svg";
export { ForwardRef as ReactComponent };